import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ThemeSwitcherService } from '../../services/theme-switcher.service';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { VersionService } from '../../services/version.service';
import * as _ from 'lodash';
import { ROLES } from '../../utils/constants';
import { PrimeNGConfig } from 'primeng/api';
import { LoadingService } from '../../services/loading.service';



@Component({
  selector: 'mapfre-auditlib-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  @Input()
  title;

  @Input()
  items;


  canShowNewPAI;
  canShowNewWork;
  canShowNewWorkers;
  canShowNewBudget;

  showPopupNew: boolean = false;
  showPopupSearch: Boolean = false;
  displayModal;
  displayButton: boolean = true;
  displayLanguageModal: Boolean = false;

  showFirstLettersUser;

  userFirstLetters;
  versionTooltip;

  currentLang;
  availableLangs;
  public loading: boolean;

  constructor(public translateService: TranslateService,
    public themeSwitcherService: ThemeSwitcherService,
    private authService: AuthService,
    private versionService: VersionService,
    private router: Router,
    private primeNGConfig: PrimeNGConfig,
    private loadingService: LoadingService) {

    this.availableLangs = [
      { code: "en", label: 'LANGUAGES.ENGLISH', img: this.getFlag("gb") },
      { code: "es", label: 'LANGUAGES.SPANISH', img: this.getFlag("es") },
      { code: "pt", label: 'LANGUAGES.PORTUGUESE', img: this.getFlag("pt") },
      { code: "pt_br", label: 'LANGUAGES.BRAZILIAN', img: this.getFlag("br") },
      { code: "tr", label: "LANGUAGES.TURKISH", img: this.getFlag("tr") }
    ]

    /*  this.availableLangs = [
      { code: "de", label: "Aleman" },
      { code: "en", label: "Ingles" },
      { code: "es", label: "Español" },
      { code: "fr", label: "Frances" },
      { code: "it", label: "Italia" },
      { code: "pt", label: "Portugues" },
      { code: "tr", label: "Turco" }
    ]*/
  }

  ngOnInit() {
    this.canShowNewPAI = this.authService.userHasAtleastOneRole([ROLES.ADMINISTRADOR, ROLES.DIRECTOR, ROLES.JEFE_DE_AREA]);
    this.canShowNewWork = this.authService.userHasAtleastOneRole([ROLES.ADMINISTRADOR, ROLES.DIRECTOR, ROLES.JEFE_DE_AREA, ROLES.AUDITOR]);
    this.canShowNewWorkers = this.authService.userHasAtleastOneRole([ROLES.ADMINISTRADOR, ROLES.DIRECTOR, ROLES.JEFE_DE_AREA]);
    this.canShowNewBudget = this.authService.userHasAtleastOneRole([ROLES.ADMINISTRADOR, ROLES.DIRECTOR, ROLES.JEFE_DE_AREA]);
    if (!this.canShowNewBudget && !this.canShowNewPAI && !this.canShowNewWork && !this.canShowNewWorkers) {
      this.displayButton = false;
    }
    this.userFirstLetters = this.authService.getUserFirstLetters();
    this.versionService.getAllVersions().subscribe(res => {
      this.versionTooltip = `
      <div class="version">
        <b>front: </b> ${_.get(res, 'front')}
        <b>aws: </b> ${_.get(res, 'aws')}
        <b>back: </b> ${_.get(res, 'back')}
      </div>
      `
    })
    let lang = this.authService.getLanguage();
    this.translateService.currentLang = lang;
    this.currentLang = this.translateService.currentLang;
    this.translateService.onLangChange.subscribe(res => {      
      this.currentLang = res.lang;
    })

    if (_.isUndefined(this.loading)) {
      this.loadingService.observer.subscribe((display) => {
        this.loading = display;
      });
    }
  }

  goRoute(route) {
    this.router.navigate([route]);
    this.showPopupNew = false;
  }

  getFlag(field) {
    return field ? "./assets/flags/" + field.toLowerCase() + ".png" : "";
  }

  showProfile() {

    let nuuma = this.authService.getNuuma();
    this.router.navigate(["/pages/user/profile/", nuuma]);
  }
  onLogoutClick() {
    this.authService.logout();
  }

  changeLanguage(lang) {
    this.translateService.resetLang(lang)
    this.translateService.use(lang);
    this.displayLanguageModal = false;
    this.translateService.get('primeng').subscribe(res => this.primeNGConfig.setTranslation(res));
  }



}
